import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { environment } from "@env/environment";
import { LoginModel } from "@models/login.model";
import { User, UserModel } from "@models/user.model";
import { map, Observable } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  static readonly ACCESS_TOKEN_KEY = "X-Xsrf-Token";
  // TODO remove when xrf token is activated
  private isLoggedOut: boolean = false;
  constructor(private http: HttpClient) {}

  get authToken(): string | null {
    return localStorage.getItem(AuthService.ACCESS_TOKEN_KEY);
  }

  get loggedOut(): boolean {
    return this.isLoggedOut;
  }

  // TODO  fix token not being taken
  extractInputValue(htmlContent: string): string | null {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = htmlContent;
    const inputElement = tempDiv.querySelector(
      'input[name="__RequestVerificationToken"]'
    );
    return inputElement ? inputElement.getAttribute("value") : null;
  }

  inputValue: any;

  getLoginInitialCookie$(): Observable<any> {
    return this.http
      .get(`${environment.BASE_URL}Account/Login`, {
        responseType: "text",
        withCredentials: true,
      })
      .pipe(
        map((response: any): Observable<any> => {
          this.inputValue = this.extractInputValue(response);
          localStorage.setItem(AuthService.ACCESS_TOKEN_KEY, this.inputValue);
          return response;
        })
      );
  }

  login$(authData: LoginModel): Observable<any> {
    const params = new URLSearchParams();
    params.set("__RequestVerificationToken", this.inputValue);
    params.set("Email", authData.email);
    params.set("Password", authData.password);

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Xsrf-Token": `${this.inputValue}`,
      "Access-Control-Allow-Origin": "*",
    });
    return this.http
      .post(`${environment.BASE_URL}Account/Login`, params, { headers })
      .pipe(
        map(() => {
          // localStorage.setItem(AuthService.ACCESS_TOKEN_KEY, response);
          return {
            // TODO replace with actual data
            email: "aaa",
            username: "bbb",
          };
        })
      );
  }

  logout$(): void {
    this.isLoggedOut = true;
    window.location.replace(`${environment.BASE_AUTH_URL}AngularHelper/LogOut`);
  }

  getUserData$(): Observable<User> {
    return this.http.get<UserModel>(`${environment.BASE_URL}self/`).pipe(
      map((userRaw: UserModel): User => {
        return User.parseDto(userRaw);
      })
    );
  }
}
